// extracted by mini-css-extract-plugin
export default {"header":"head_header__L026Z"};